"use client";

import * as React from "react";
import { useToast } from "@/hooks/use-toast";
import {
  ToastViewport,
  Toast,
  ToastTitle,
  ToastDescription,
  ToastClose,
} from "@/components/ui/toast";

export function Toaster() {
  const { toasts, toast } = useToast();

  return (
    <ToastViewport>
      {toasts.map(({ id, title, description, action, variant, visible }) => (
        <Toast key={id} id={id} variant={variant} visible={visible}>
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && (
              <ToastDescription>{description}</ToastDescription>
            )}
          </div>
          {action}
          <ToastClose onClick={() => toast.dismiss(id)} />
        </Toast>
      ))}
    </ToastViewport>
  );
}
